<template>
  <div class="container">
    <div class="head">
      <span style="cursor: pointer">
        <img src="../../../static/qi_logo.png" alt="" @click="toIndex" />
      </span>
    </div>
    <div class="main">
      <div class="main-content" style="height: 100%">
        <div class="left"><img src="../../../static/login/loginad.png" alt="" /></div>
        <div class="right-box">
          <login-box v-if="type == 1" @changeType="changeType"></login-box>
          <register-box v-else @changeType="changeType"></register-box>
        </div>
      </div>
    </div>
    <div class="footer">
      <div style="margin-right: 10px">荷塘查策网</div>
      <div>湘ICP备2023013557号</div>
    </div>
  </div>
</template>

<script>
import loginBox from "./components/loginBox.vue";
import registerBox from "./components/registerBox.vue";
export default {
  components: { loginBox, registerBox },
  data() {
    return {
      type: 1, //1 登录 2 注册
    };
  },
  mounted() {
    if (this.$route.query.key == "0") {
      this.type = 1;
    } else if (this.$route.query.key == "1") {
      this.type = 2;
    }
  },
  methods: {
    toIndex() {
      this.$router.push("/");
    },
    async checkInfo() {
      let date = new Date().getTime();
      let loginInfo = localStorage.getItem("loginInfo");
      if (!loginInfo) {
        return;
      }
      if (loginInfo.saveTime == -1) {
        localStorage.removeItem("loginInfo");
      } else {
        if (date > loginInfo.saveTime) {
          localStorage.removeItem("loginInfo");
        } else {
          this.$router.push("/");
        }
      }
    },
    changeType(value) {
      this.type = value;
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;

  .head {
    background-color: #fff;
    width: 1200px;
    margin: 30px auto;
    height: 60px;
    text-align: left;
    font-size: 30px;
    line-height: 60px;
  }

  .main {
    background: #eee;
    color: #1a1a1a;
    width: 100%;
    padding-top: 30px;
    margin: 0;
    height: 713px;
    box-sizing: border-box;

    &-content {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .left {
      width: 618px;
      height: 480px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .right-box {
      width: 400px;
      //   height: 400px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      .login {
        width: 400px;
        // height: 296px;
        padding: 0 30px;
        box-sizing: border-box;
        background-color: #fff;
        border-radius: 5px;

        .accountLogin {
          width: 60px;
          height: 52px;
          line-height: 52px;
          text-align: left;
          margin-bottom: 20px;
          font-family: PingFangSC-Regular, sans-serif;
          border-bottom: 2px solid #409eff;
        }

        ::v-deep .el-input__inner {
          border: none !important;
        }

        ::v-deep .el-input__inner {
          background-color: transparent !important;
          color: #1a1a1a !important;
          border: none;
          padding: 0;
        }

        ::v-deep .el-input__inner::placeholder {
          color: #1a1a1a;
        }

        .input {
          margin-bottom: 20px;
          position: relative;
        }

        .el-input:hover::before {
          background: #ccc;
          content: "";
          position: absolute;
          width: 100%;
          height: 1px;
          left: 0;
          bottom: 0;
        }

        .forget {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .forgetPwd {
            color: #8590a6;
            cursor: pointer;
            transition: all 0.3s linear 0s;
          }

          .forgetPwd:hover {
            color: inherit;
          }
        }

        .loginBtn {
          width: 340px;
          height: 60px;
          margin: 20px auto;
          background: #409eff;
          color: #fff;
          cursor: pointer;
          line-height: 60px;
          border-radius: 5px;
          font-size: 16px;
          text-align: center;
          transition: all 0.3s linear 0s;
        }
        .loginBtn:hover {
          opacity: 0.7;
        }
      }

      .rigster {
        line-height: 60px;
        height: 60px;
        width: 400px;
        border-radius: 5px;
        font-size: 16px;
        text-align: center;
        margin: 10px auto 0;
        transition: all 0.3s linear 0s;
        background: #409eff;
        color: #fff;
        cursor: pointer;

        .huiyuan {
          width: 16px;
          height: 18px;
          display: inline-block;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-image: url("../../../static/huiyuan.png");
          vertical-align: middle;
          margin-right: 5px;
        }
      }

      .rigster:hover {
        opacity: 0.7;
      }
    }
  }
}

.footer {
  background: #fff !important;
  color: #8590a6;
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
